export default "__VITE_ASSET__TiubQ$Ao__"